import { TEFComponentConfig } from 'src/tef/components/config/componentConfig';

import { ComponentSize } from './types';

/**
 * Maps component size to appropriate border radius
 * Ensures consistency across all components based on size
 */
export const getBorderRadiusBySize = (size: ComponentSize, tef: TEFComponentConfig): string => {
  const sizeToRadiusMap: Record<ComponentSize, keyof TEFComponentConfig['borderRadius']> = {
    xs: 'sm',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
  };

  const radiusKey = sizeToRadiusMap[size];
  return tef.borderRadius[radiusKey];
};
